import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatMenuModule} from '@angular/material/menu';
import {MatToolbarModule} from '@angular/material/toolbar';

import {FuseSearchBarModule, FuseShortcutsModule} from '@fuse/components';
import {FuseSharedModule} from '@fuse/shared.module';

import {ToolbarComponent} from '@app/components-fuse/layout/components/toolbar/toolbar.component';
import {TranslateModule} from '@ngx-translate/core';
import {IdleAndWhoIsOnlineModule} from '@app/services/IdleAndWhoseOnline/idle-and-who-is-online.module';
import {LiveWorkersComponent} from '@app/4dm1n/works-dashboard/live-workers/live-workers.component';
import {ReferencesTitleComponent} from '../../../../../@shared/_referencesLists/reference-lists/components/references-title/references-title.component';
import {FullSearchComponent} from '../../../../../@shared/_referencesLists/full-search/full-search.component';
import {LoadingDirectiveModule} from '../../../../../@shared/loading-directive/loading-directive.module';
import {IfDebugModeDirective} from '../../../../../@shared/loading-directive/if-debug-mode.directive';
import {DisplayStoreTreePopupComponent} from '@app/4dm1n/store-tree/display-store-tree-popup/display-store-tree-popup.component';
import {DxToolbarModule} from 'devextreme-angular';
import {ChatBoxButtonComponent} from '../../../../../@shared/aiStuff/chat-box-button/chat-box-button.component';
import {MatTooltipModule} from "@angular/material/tooltip";
import {
    ToolbarToolPopupComponent
} from "@app/components-fuse/layout/components/toolbar/toolbar-tool-popup/toolbar-tool-popup.component";

@NgModule({
  declarations: [ToolbarComponent],
  imports: [RouterModule,
    MatButtonModule, MatIconModule,
    MatMenuModule, MatToolbarModule,
    FuseSharedModule, FuseSearchBarModule, FuseShortcutsModule, TranslateModule, IdleAndWhoIsOnlineModule, LiveWorkersComponent, ReferencesTitleComponent, FullSearchComponent,
    LoadingDirectiveModule, IfDebugModeDirective, DisplayStoreTreePopupComponent, DxToolbarModule, ChatBoxButtonComponent, MatTooltipModule, ToolbarToolPopupComponent
  ],
  exports: [ToolbarComponent],
})
export class ToolbarModule {
}
